module.exports = __webpack_public_path__ + "img/logo1.b42e3073.png";